<ion-item class="input-date-picker" *transloco="let t">
  <ion-label
    position="stacked"
    [ngStyle]="{ visibility: showLabel ? 'visible' : 'hidden' }"
    >{{ label }}</ion-label
  >
  <div>
    <ion-select
      *ngIf="showDay"
      [placeholder]="t('common.day')"
      [cancelText]="t('common.cancel')"
      [(ngModel)]="day"
      (ngModelChange)="handleChange()"
      [ngClass]="{
        error: error
      }"
    >
      <ion-select-option *ngFor="let opt of dayOptions" [value]="opt.value">{{
        opt.label
      }}</ion-select-option>
    </ion-select>

    <ion-select
      class="month-picker"
      [placeholder]="t('common.month')"
      [cancelText]="t('common.cancel')"
      [(ngModel)]="month"
      (ngModelChange)="handleChange()"
      [ngClass]="{
        error: error
      }"
    >
      <ion-select-option *ngFor="let opt of monthOptions" [value]="opt.value">{{
        opt.label
      }}</ion-select-option>
    </ion-select>

    <ion-select
      [placeholder]="t('common.year')"
      [cancelText]="t('common.cancel')"
      [(ngModel)]="year"
      (ngModelChange)="handleChange()"
      [ngClass]="{
        error: error
      }"
    >
      <ion-select-option *ngFor="let opt of yearOptions" [value]="opt.value">{{
        opt.label
      }}</ion-select-option>
    </ion-select>
  </div>

  <span *ngIf="error" class="error">{{ error ? error : t('common.required') }}</span>
</ion-item>
